module.exports = __webpack_public_path__ + "img/btDiscard.2d3c7d8b.gif";